import http from "../http";

import TokenService from "./token.service";

const AuthService = {
    hasPermission: (permission) => {
        const user = JSON.parse(localStorage.getItem("EFFuser"));
        // console.log(user, user.permissions);
        return user.permissions && user.permissions.includes(permission)
    },

    /*20220601
    api_enumADOUList: async () => {
        const response = await http.instance.get("/auth/getldapoulist");
        console.log(response.data);
        return response.data;
    },
    */

    getIsProdEnvironment_service: async () => {

        const response = await http.instance.get("/auth/getIsProdEnvironment");
        return response.data;
    },

    login: async (email, password, selectedOU) => {

        const response = await http.instance.post("/auth", {email: email, password: password, selectedOU:selectedOU});
        TokenService.setToken(response.data.access_token, response.data.refresh_token);
        localStorage.setItem("EFFuser", JSON.stringify(response.data.user));

        http.setHeader();
        http.mountAuthInterceptor();

        return response.data.user;
    },

    refreshToken: async () => {
        const response = await http.instance.post("/auth/refresh", {refresh_token: TokenService.getRefreshToken()});

        TokenService.setToken(response.data.access_token, response.data.refresh_token);
        localStorage.setItem("EFFuser", JSON.stringify(response.data.user));

        http.setHeader();

        return response.data.user;
    },

    logout: () => {
        TokenService.removeToken();
        localStorage.removeItem("EFFuser");

        http.clearHeader();
        http.unmountAuthInterceptor();
    }
};

export default AuthService
